/**
 * IQVIA brand + app title for NavigationBar LogoComponent.
 * Inline styles mirror legacy HeaderBar.applicationName spacing (no right border post-rebrand).
 */
import React from 'react';
import Typography from 'apollo-react/components/Typography';
import { APP_TITLE, BRAND_NAME } from './navigationBarConfig';

const SparkHeaderLogo = () => (
    <Typography
        style={{
            color: '#fff',
            lineHeight: '56px',
            padding: '8px 36px 8px 12px',
            whiteSpace: 'nowrap',
            fontWeight: 400,
            zIndex: 2,
        }}
    >
        {BRAND_NAME}{' '}
        <span style={{ fontWeight: 600 }}>{APP_TITLE}</span>
    </Typography>
);

export default SparkHeaderLogo;
